import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const WxActivityDetail = () => {
  const { id } = useParams();
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`/api/activities/${id}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then(res => res.json())
      .then(data => setActivity(data)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{textAlign:'center',marginTop:'30vh'}}>加载中…</div>;
  if (!activity || activity.message) return <div style={{textAlign:'center',marginTop:'30vh'}}>活动不存在</div>;

  return (
    <div style={{padding:16,maxWidth:400,margin:'0 auto',fontFamily:'-apple-system,BlinkMacSystemFont,Segoe UI'}}>
      <h2 style={{textAlign:'center'}}>{activity.name}</h2>
      <div style={{background:'#f7f7f7',borderRadius:8,padding:12,marginBottom:16}}>
        <div><b>时间：</b>{activity.start_time} ~ {activity.end_time}</div>
        <div><b>地点：</b>{activity.location || '-'}</div>
        <div><b>描述：</b>{activity.description || '-'}</div>
      </div>
      <button style={{width:'100%',padding:'10px 0',border:'none',borderRadius:4,background:'#07c160',color:'#fff',fontSize:16}} onClick={()=>window.location.href='/wx/activity'}>返回活动列表</button>
    </div>
  );
};

export default WxActivityDetail;
